import React from 'react';
import { 
  Briefcase,     // For WorkSafeBC/ICBC
  FileHeart,     // For Disability/EI certificates
  FileCheck,     // For Return-to-work clearance
  Shield,    // For Insurance forms
  Dumbbell       // For Fitness/Camp forms
} from 'lucide-react';

// Icon configuration
const ICON_SIZE = 40;
const ICON_COLOR = "#0073a8"; // Blue to complement the pink in How It Works section

const FormExample = () => {
  return (
    <div className="form-examples mb-70">
      <div className="row">
        <div className="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
          <div className="section-title text-center pos-rel mb-40">
            <div className="section-icon">
              {/* <img className="section-back-icon" src="img/section/section-back-icon.png" alt="" /> */}
            </div>
            <div className="section-text pos-rel">
              <h5>Services</h5>
              <h2>Examples of Forms We Complete</h2>
            </div>
            <div className="section-line pos-rel">
              <img src="img/shape/section-title-line.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">
          <div className="services-wrapper">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="service-box text-center mb-30">
                  <div className="service-thumb">
                    <Briefcase size={ICON_SIZE} color={ICON_COLOR} />
                  </div>
                  <div className="service-content">
                    <h3>WorkSafeBC or ICBC Reports</h3>
                    <p>Injury documentation and assessments for workplace or motor vehicle incidents.</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="service-box text-center mb-30">
                  <div className="service-thumb">
                    <FileHeart size={ICON_SIZE} color={ICON_COLOR} />
                  </div>
                  <div className="service-content">
                    <h3>Disability or EI Medical Certificates</h3>
                    <p>Medical documentation for disability claims or Employment Insurance benefits.</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="service-box text-center mb-30">
                  <div className="service-thumb">
                    <FileCheck size={ICON_SIZE} color={ICON_COLOR} />
                  </div>
                  <div className="service-content">
                    <h3>Return-to-work/school Clearance</h3>
                    <p>Documentation confirming medical clearance to return to work or school.</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="service-box text-center mb-30">
                  <div className="service-thumb">
                    <Shield size={ICON_SIZE} color={ICON_COLOR} />
                  </div>
                  <div className="service-content">
                    <h3>Insurance or Benefits Forms</h3>
                    <p>Medical documentation needed for insurance claims or benefit applications.</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 offset-xl-3 col-lg-6 offset-lg-3 col-md-6 offset-md-3">
                <div className="service-box text-center mb-30">
                  <div className="service-thumb">
                    <Dumbbell size={ICON_SIZE} color={ICON_COLOR} />
                  </div>
                  <div className="service-content">
                    <h3>Fitness or Camp Forms</h3>
                    <p>Medical clearance forms for physical activities, sports, or camp attendance.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormExample;